import axios from 'axios'

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  },
  timeout: 10000 //Throw error if API call takes longer than 10 sec//
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.authorization = 'Bearer '+ token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default {
    upsertOrder(orderBody) {
      return apiClient.post('/order', orderBody)
    },
    fetchReview() {
      return apiClient.get('/check/review/status')
    },
    saveReview(reviewJson) {
      return apiClient.post('/service/review', reviewJson)
    }
}